export default "__VITE_ASSET__DJkUW78Q__"